module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8499/img/InterstitialBlobs.png"